export default __webpack_public_path__ + "static/userJoin6-795b282fa22929229fd5311898c3bb88.jpg";